// extracted by mini-css-extract-plugin
module.exports = {"NewGamePlatformsBlock":"NewPlatform_NewGamePlatformsBlock__3QBy5"};